const MAXIMO_AVANCE_FISICO = 100;
const DECIMALES_PONDERADO = 3;

export function validarAvanceFisico(valor) {
  if (valor === '' || valor === null || valor === undefined) return false;
  const numero = Number(valor);
  return Number.isFinite(numero)
    && numero >= 0
    && numero <= MAXIMO_AVANCE_FISICO
    && Math.abs((numero * 100) - Math.round(numero * 100)) < 1e-8;
}

export function limitarAvanceFisico(valor) {
  const numero = Number(valor);
  if (!Number.isFinite(numero)) return 0;
  return Math.min(MAXIMO_AVANCE_FISICO, Math.max(0, numero));
}

export function redondearPonderado(valor) {
  const numero = Number(valor);
  if (!Number.isFinite(numero)) return 0;
  const factor = 10 ** DECIMALES_PONDERADO;
  return Math.round((numero + Number.EPSILON) * factor) / factor;
}

export function calcularAvancePonderado(ponderadoPartida, avanceFisico) {
  const ponderado = redondearPonderado(ponderadoPartida);
  const avance = limitarAvanceFisico(avanceFisico);
  return redondearPonderado(ponderado * (avance / MAXIMO_AVANCE_FISICO));
}

export function sumarAvancesPonderados(partidas) {
  const suma = partidas.reduce((total, partida) => (
    total + Number(partida.avancePonderado || 0)
  ), 0);
  const redondeada = Math.round((suma + Number.EPSILON) * 100) / 100;
  return Math.min(MAXIMO_AVANCE_FISICO, Math.max(0, redondeada));
}
